import { NavigationActions } from 'react-navigation'
import { changeRoute } from '../redux/ui'
import { logout } from '../redux/auth'
import { addGlobalError } from '../redux/error'

let navigator
let authNavigator
let store

function setStore (storeRef) {
  store = storeRef
}

function setTopLevelNavigator (navigatorRef) {
  navigator = navigatorRef
}

function setAuthNavigator (navigatorRef) {
  authNavigator = navigatorRef
}

function navigate (routeName, params) {
  store.dispatch(changeRoute(routeName))
  navigator.dispatch(
    NavigationActions.navigate({
      routeName,
      params
    })
  )
}

function doLogout () {
  store.dispatch(logout(authNavigator))
}

function doError ({ message, notRetryable }) {
  store.dispatch(addGlobalError(null, { message, notRetryable }, authNavigator))
}

export default {
  navigate,
  setTopLevelNavigator,
  setAuthNavigator,
  setStore,
  doLogout,
  doError
}
